var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalRope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.617,
    height: 673.303,
    viewBox: "0 0 104.617 673.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(56 -5669.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(-42 6269)",
    fill: "#a79c86",
    stroke: "#c2b59c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 32.5,
    rx: 38.5,
    ry: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 32.5,
    rx: 38,
    ry: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "translate(-42 5682)",
    fill: "#aea490",
    stroke: "#c2b59c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 26.5,
    rx: 38.5,
    ry: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 26.5,
    rx: 38,
    ry: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ropes",
    transform: "translate(2.75 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-368.191 5858.797) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.121 5898.797) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.085 5937.967) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-368.191 5858.797) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.121 5898.797) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.085 5937.967) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(1.277 39.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-2",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(1.277 77.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321-3",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-3",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(1.277 115.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321-4",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-4",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(1.277 153.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321-5",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-5",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(1.277 190.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321-6",
    "data-name": "Path 321",
    d: "M242.7,302.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.671,26.671,0,0,1,242.7,302.4Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-6",
    "data-name": "Path 322",
    d: "M232.8,313.4a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.459,14.459,0,0,1,232.8,313.4Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C233,248.4,232.6,248.3,232.1,248.3Z",
    transform: "translate(-367.048 5977.258) rotate(-45)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M268.7,276.4l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.28,26.28,0,0,1,268.7,276.4Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M258.8,287.3a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2h0l-3.2,3.2A14.459,14.459,0,0,1,258.8,287.3Zm-.6-65a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1A3.75,3.75,0,0,0,258.2,222.3Zm10.5,54.1Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M294.3,250.7l-3.2,3.2a9.478,9.478,0,0,1-15.8-4l-8-26.2a26.225,26.225,0,0,1,6.6-26.2l3.2-3.2a9.478,9.478,0,0,1,15.8,4l8,26.2A26.17,26.17,0,0,1,294.3,250.7Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M284.5,261.7a14.723,14.723,0,0,1-3.6-.4,14.273,14.273,0,0,1-10.4-9.9l-8-26.2a31.075,31.075,0,0,1,7.8-31.2l3.2-3.2a14.56,14.56,0,0,1,24.2,6.1l8,26.2a31.075,31.075,0,0,1-7.8,31.2l-3.2,3.2A14.635,14.635,0,0,1,284.5,261.7Zm-.7-65.1a4.767,4.767,0,0,0-3.2,1.3l-3.2,3.2a21.114,21.114,0,0,0-5.3,21.2l8,26.2a4.652,4.652,0,0,0,3.2,3.1,4.532,4.532,0,0,0,4.3-1.2l3.2-3.2h0a21.114,21.114,0,0,0,5.3-21.2l-8-26.2a4.652,4.652,0,0,0-3.2-3.1C284.7,196.7,284.3,196.6,283.8,196.6Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M193,324.4l5.3,16.7a8.032,8.032,0,0,0,13.4,3.2L226,330a8.232,8.232,0,0,0,2-8.2l-5.3-16.7a8.032,8.032,0,0,0-13.4-3.2L195,316.2A8.232,8.232,0,0,0,193,324.4Z",
    transform: "translate(-367.814 5968.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M206.1,351.7a11,11,0,0,1-3.1-.4,12.927,12.927,0,0,1-9.4-8.7l-5.3-16.7h0a12.923,12.923,0,0,1,3.2-13.2l14.2-14.2a13.062,13.062,0,0,1,21.7,5.2l5.3,16.7a12.923,12.923,0,0,1-3.2,13.2l-14.2,14.2A13.042,13.042,0,0,1,206.1,351.7Zm-8.3-28.9,5.3,16.7a3.312,3.312,0,0,0,2.2,2.1,3.079,3.079,0,0,0,2.9-.8l14.2-14.2a3.211,3.211,0,0,0,.8-3.1l-5.3-16.7a3.312,3.312,0,0,0-2.2-2.1,3.079,3.079,0,0,0-2.9.8l-14.2,14.2a2.812,2.812,0,0,0-.8,3.1Z",
    transform: "translate(-367.814 5968.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M180.6,291.7l5.3,16.7a8.032,8.032,0,0,0,13.4,3.2l14.2-14.2a8.232,8.232,0,0,0,2-8.2l-5.3-16.7a8.032,8.032,0,0,0-13.4-3.2l-14.2,14.2A8.232,8.232,0,0,0,180.6,291.7Z",
    transform: "translate(-367.814 5968.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M193.7,319a11,11,0,0,1-3.1-.4,12.927,12.927,0,0,1-9.4-8.7l-5.3-16.7a12.923,12.923,0,0,1,3.2-13.2l14.2-14.2A13.062,13.062,0,0,1,215,271l5.3,16.7a12.923,12.923,0,0,1-3.2,13.2l-14.2,14.2A13.042,13.042,0,0,1,193.7,319Zm8.8-47.1a3.337,3.337,0,0,0-2.2.9L186.2,287a3.211,3.211,0,0,0-.8,3.1h0l5.3,16.7a3.312,3.312,0,0,0,2.2,2.1,3.079,3.079,0,0,0,2.9-.8L210,293.9a3.211,3.211,0,0,0,.8-3.1l-5.3-16.7a3.312,3.312,0,0,0-2.2-2.1A1.949,1.949,0,0,0,202.5,271.9Z",
    transform: "translate(-367.814 5968.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-367.814 5968.157) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M186,308.3l-35.7,18.8a9.487,9.487,0,0,0-1.7,15.7l25.5,21.7a9.5,9.5,0,0,0,14.8-3.2l9.6-20.3Z",
    fill: "#faf8f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M180.1,371.8a14.424,14.424,0,0,1-9.4-3.5l-25.5-21.7a14.3,14.3,0,0,1-5-12.7,14.557,14.557,0,0,1,7.7-11.3l35.7-18.8a4.93,4.93,0,0,1,4.1-.3,5.168,5.168,0,0,1,2.9,2.9L203,339.1a4.812,4.812,0,0,1-.2,3.9l-9.6,20.3a14.44,14.44,0,0,1-10.1,8A7.286,7.286,0,0,1,180.1,371.8Zm3.2-56.4-30.7,16.2a4.67,4.67,0,0,0-2.4,3.5,4.175,4.175,0,0,0,1.6,3.9l25.5,21.7a4.6,4.6,0,0,0,3.9,1,4.368,4.368,0,0,0,3.1-2.5l8.7-18.4Z",
    fill: "#c2b59c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M300.3,217.1l5.3,16.7A8.031,8.031,0,0,0,319,237l14.2-14.2a8.232,8.232,0,0,0,2-8.2l-5.3-16.7a8.031,8.031,0,0,0-13.4-3.2L302.2,209A8.016,8.016,0,0,0,300.3,217.1Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M313.3,244.4a11,11,0,0,1-3.1-.4,12.927,12.927,0,0,1-9.4-8.7l-5.3-16.7a12.923,12.923,0,0,1,3.2-13.2l14.2-14.2a13.062,13.062,0,0,1,21.7,5.2l5.3,16.7a12.923,12.923,0,0,1-3.2,13.2l-14.2,14.2A12.319,12.319,0,0,1,313.3,244.4Zm8.8-47.1a3.337,3.337,0,0,0-2.2.9l-14.2,14.2a3.211,3.211,0,0,0-.8,3.1h0l5.3,16.7a3.312,3.312,0,0,0,2.2,2.1,3.079,3.079,0,0,0,2.9-.8l14.2-14.2a3.211,3.211,0,0,0,.8-3.1L325,199.5a3.312,3.312,0,0,0-2.2-2.1A5.638,5.638,0,0,0,322.1,197.3Z",
    transform: "translate(-367.814 5823.157) rotate(-45)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-367.814 5823.157) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M287.9,184.4l5.3,16.7a8.031,8.031,0,0,0,13.4,3.2l14.2-14.2a8.232,8.232,0,0,0,2-8.2l-5.3-16.7a8.031,8.031,0,0,0-13.4-3.2l-14.2,14.2A8.12,8.12,0,0,0,287.9,184.4Z",
    fill: "#c2b59c",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M300.9,211.7a11,11,0,0,1-3.1-.4,12.927,12.927,0,0,1-9.4-8.7l-5.3-16.7a12.923,12.923,0,0,1,3.2-13.2l14.2-14.2a13.062,13.062,0,0,1,21.7,5.2l5.3,16.7a12.923,12.923,0,0,1-3.2,13.2l-14.2,14.2A12.319,12.319,0,0,1,300.9,211.7Zm8.8-47a3.337,3.337,0,0,0-2.2.9l-14.2,14.2a3.211,3.211,0,0,0-.8,3.1h0l5.3,16.7a3.312,3.312,0,0,0,2.2,2.1,3.079,3.079,0,0,0,2.9-.8l14.2-14.2a3.211,3.211,0,0,0,.8-3.1l-5.3-16.7a3.312,3.312,0,0,0-2.2-2.1C310.3,164.7,310,164.7,309.7,164.7Z",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-367.814 5823.157) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M321.5,172.8l8.9-25.8a9.487,9.487,0,0,1,15.7-1.7l21.7,25.5a9.5,9.5,0,0,1-3.2,14.8L329.9,198Z",
    fill: "#faf8f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M329.9,203a5.45,5.45,0,0,1-2.2-.5,5.3,5.3,0,0,1-2.6-2.9l-8.3-25.2a5.8,5.8,0,0,1,0-3.2l8.9-25.8c.1-.2.2-.5.3-.7a14.607,14.607,0,0,1,24-2.7l21.7,25.5a14.182,14.182,0,0,1,3.1,12.5,14.642,14.642,0,0,1-8,10.1c-.1.1-.3.1-.4.2l-34.7,12.5A14.055,14.055,0,0,1,329.9,203Zm-3.1-30.2,6.2,18.7,29.6-10.6a4.392,4.392,0,0,0,2.3-3,4.6,4.6,0,0,0-1-3.9l-21.7-25.5a4.515,4.515,0,0,0-3.9-1.6A4.41,4.41,0,0,0,335,149Z",
    fill: "#c2b59c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalRope);
export default __webpack_public_path__ + "static/media/verticalRope.546406ce9235f1f4edf3bb9557a5e432.svg";
export { ForwardRef as ReactComponent };